import { isCurrencyCodeType } from '@shared/utils/currency/currency.constants';
import type { TravelCurrencyCodesPayload } from './TravelCurrencySelector.types';
import type { CurrencyCodeType } from '@shared/utils/currency/currency.types';

const filterValidCurrencyCodes = (value: unknown): ReadonlyArray<CurrencyCodeType> | undefined => {
  if (!Array.isArray(value)) return undefined;
  const valid = value.filter(isCurrencyCodeType);
  return valid.length > 0 ? valid : undefined;
};

export const parseCurrencyPayload = (raw: unknown): TravelCurrencyCodesPayload | undefined => {
  if (!raw || typeof raw !== 'object') return undefined;
  const obj = raw as Record<string, unknown>;
  return {
    popularCurrencyCodes: filterValidCurrencyCodes(obj.popularCurrencyCodes),
    allCurrencyCodes: filterValidCurrencyCodes(obj.allCurrencyCodes),
  };
};
